const shadows = {
  containerShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.55)',
  menuListShadow: '0px 4px 12px 0px rgba(0, 0, 0, 0.45)',
  guideItemShadow: '0px 3.693px 3.693px 0px rgba(0, 0, 0, 0.55)',
};

export default shadows;
